<div class="min-h-screen py-8">
  <div class="max-w-6xl mx-auto px-4">
    <!-- Header -->
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">Panel de Multicomercio</h1>
      <p class="text-gray-600">Todo lo de los comercios aliados: estructura, altas, liquidación e integración</p>
    </div>

    <!-- Lista de Opciones -->
    <div class="space-y-3">
      <a *ngFor="let option of opciones" [routerLink]="[option.route]" class="block bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400">
        <div class="flex items-center p-4">
          <div class="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center mr-4" [ngClass]="option.color">
            <i [class]="option.icon + ' text-2xl'"></i>
          </div>
          <div class="flex-1 min-w-0">
            <h3 class="text-lg font-semibold text-gray-900">{{ option.title }}</h3>
            <p class="text-sm text-gray-600">{{ option.description }}</p>
          </div>
          <div class="flex-shrink-0 ml-4">
            <i class="fas fa-chevron-right text-gray-400"></i>
          </div>
        </div>
      </a>
      <p *ngIf="!opciones.length" class="text-center text-gray-600">No tienes acceso a ninguna opción de Multicomercio.</p>
    </div>
  </div>
</div>
